// Name lookup ladder for a staff rlid: case participant, then the staff
// directory, then the viewing user (their own profile is not in staffMap)
const resolveStaffName = (rlid, { participants, staffMap, authInfo }) => {
  const participant = participants?.find((part) => (part.crRlid === rlid));
  if (participant?.shortName) return participant.shortName;

  const staff = staffMap?.get(rlid);
  if (staff) return `${staff.fname ?? ''} ${staff.lname ?? ''}`.trim();

  if (rlid === authInfo?.rlid) {
    return `${authInfo?.fname ?? ''} ${authInfo?.lname ?? ''}`.trim();
  }

  return null;
};

export default resolveStaffName;
